import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Button, CircularProgress } from '@material-ui/core';

class FHEToggleButton extends PureComponent {
    static propTypes = {
        checked: PropTypes.bool,
        loading: PropTypes.bool,
        disabled: PropTypes.bool,
        content: PropTypes.string.isRequired,
        handler: PropTypes.func.isRequired,
        fullWidth: PropTypes.bool,
        color: PropTypes.string,
        size: PropTypes.string,
        className: PropTypes.string,
        classes: PropTypes.object.isRequired
    };

    static defaultProps = {
        checked: false,
        loading: false,
        disabled: false,
        fullWidth: true,
        color: 'primary',
        className: '',
        size: 'medium'
    };

    render() {
        const { loading, content, handler, fullWidth, color, className, size, disabled, classes, checked } = this.props;
        return (
            <Button
                className={checked ? `${classes.FHEButton} ${className} ${classes.selected}` : `${classes.FHEButton} ${className}`}
                fullWidth={fullWidth}
                disabled={disabled || loading}
                variant="contained"
                onClick={handler}
                size={size}
            >
                {!loading ? content : <CircularProgress color={color} size={20} />}
            </Button>
        );
    }
}

const styles = theme => ({
    FHEButton: {
        margin: '10px 5px'
    },
    selected: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark
        }
    }
});

export default withStyles(styles, { withTheme: true })(FHEToggleButton);



// WEBPACK FOOTER //
// ./data/components/FHEToggleButton.js